module.exports = __webpack_public_path__ + "static/resume-6aeab0f7a22c8fcd6e217c9500cb4ff2.pdf";